<!-- *************************************************************************************************** -->
                        <!-- Dialog box displaying data is loading -->
<!-- *************************************************************************************************** -->
<div class="loading-box">
    <h3 class="loading-header">{{data}}</h3>
    <mat-spinner mode="indeterminate" class="loading-spinner"></mat-spinner>
</div>